import * as Yup from "yup";

export const updateProductStockValidation = Yup.object().shape({
  stock: Yup.string().required("وارد کردن موجودی جدید الزامی است"),
});
